import React from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";

/**
 * Sort picker: the sort options, then the active sort's direction switch and,
 * for a date sort (`groupsByMonth` on its option), a "Group by month" switch.
 *
 * @param {boolean} [groupByMonth] - Whether a date sort's list is grouped
 * @param {() => void} [onGroupByMonthToggle] - Omit where grouping isn't offered
 */
const SortMenu = ({
  anchorEl,
  onClose,
  onSelect,
  sortByValue,
  toggleValue,
  onToggle,
  sortByOptions,
  groupByMonth,
  onGroupByMonthToggle,
}) => {
  const currentOption = sortByOptions.find(
    (option) => option.value === sortByValue,
  );

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{
        paper: {
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))", // adds shadow around menu
            mt: 1.5,
          },
        },
      }}
    >
      {sortByOptions.map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => onSelect(option.value)}
          selected={option.value === sortByValue}
          disabled={option?.disabled}
          dense
        >
          <ListItemIcon>{option.icon}</ListItemIcon>
          {option.label}
        </MenuItem>
      ))}
      <Divider />
      <MenuItem dense>
        <FormControlLabel
          control={<Switch checked={toggleValue} onChange={onToggle} />}
          label={
            <Typography variant="body2">
              {currentOption?.toggleLabel ?? "Most recent first"}
            </Typography>
          }
        />
      </MenuItem>
      {onGroupByMonthToggle && currentOption?.groupsByMonth && (
        <MenuItem dense>
          <FormControlLabel
            control={
              <Switch checked={groupByMonth} onChange={onGroupByMonthToggle} />
            }
            label={<Typography variant="body2">Group by month</Typography>}
          />
        </MenuItem>
      )}
    </Menu>
  );
};

export default SortMenu;
